import { render, staticRenderFns } from "./HighLight.vue?vue&type=template&id=473b722c"
import script from "./HighLight.vue?vue&type=script&lang=js"
export * from "./HighLight.vue?vue&type=script&lang=js"
import style0 from "./HighLight.vue?vue&type=style&index=0&id=473b722c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports